import { ToolListItem } from '../../model/tool-list-item.model';
import { ToolLocationListItem } from '../../model/tool-location-list-item.model';
import {ProjectListItem} from '../../model/project-list.item';


export class DisplayHelper {

  public static readonly toolDisplayFn = (tool: ToolListItem): string => {
    if (!tool) {
      return '';
    }
    return `${DisplayHelper.getValueOrEmpty(tool.category)} ${DisplayHelper.getValueOrEmpty(tool.rfid)}`;
  };

  public static readonly locationDisplayFn = (location: ToolLocationListItem): string => {
    if (!location) {
      return '';
    }
    return `${DisplayHelper.getValueOrEmpty(location.locationPretty)} ${DisplayHelper.getValueOrEmpty(location.rfid)}`;
  };

  public static readonly projectDisplayFn = (project: ProjectListItem): string => {
    if (!project) {
      return '';
    }

    const amount = DisplayHelper.getValueOrEmpty(project.amount);

    return `${DisplayHelper.getValueOrEmpty(project.projectType)} ${DisplayHelper.getValueOrEmpty(project.number)}${amount ? `, Bestand: ${amount}` : ''}`;
  };

  public static readonly projectDisplayWithInventoryFn = (
      project: ProjectListItem,
      inventoryLoc: string
    ): string => {
    if (!project) {
      return '';
    }

    const amount = DisplayHelper.getValueOrEmpty(project.amount);

    return `${DisplayHelper.getValueOrEmpty(project.projectType)} ${DisplayHelper.getValueOrEmpty(project.number)}${amount ? `, ${inventoryLoc}: ${amount}` : ''}`;
  };

  public static readonly getValueOrEmpty = (option: any): string => {
    if (!option) {
      return '';
    }
    return option;
  };


}
